import React from 'react'
import CheckedIcon from '../../images/Checkbox.svg'
import UnCheckedIcon from '../../images/afternoon_checkbox.svg'
import RequiredAsteriskComponent from 'components/required-asterisk'

import './index.css'

interface CheckboxComponentProps {
  isChecked: boolean
  label?: React.ReactNode
  isRequired?: boolean
  data_testid?: string
  onClick?: (event?: React.MouseEvent) => void
}

const CheckboxComponent = (props: CheckboxComponentProps): JSX.Element => {
  const { isChecked, label = '', isRequired = false, onClick, data_testid = 'CheckBoxOutlineBlankIcon' } = props

  return (
    <div className='flex items-center' data-testid={data_testid}>
      <img
        src={isChecked ? CheckedIcon : UnCheckedIcon}
        alt={isChecked ? 'Checked' : 'Unchecked'}
        className='mr-2 cursor-pointer'
        onClick={onClick}
      />
      <span
        className='text-gray-400 text-sm font-medium py-2'
        style={{ flex: 1, margin: 0, padding: 0, display: 'block', alignSelf: 'center', textAlign: 'left' }}
      >
        {label}
        {isRequired && <RequiredAsteriskComponent />}
      </span>
    </div>
  )
}

export default CheckboxComponent
